<div class="cx-anonymous-consent-dialog">
  <div class="cx-dialog-content">
    <ng-template #dialogBody>
      <div role="status"></div>
      <div class="cx-dialog-header">
        <h3>AA</h3>
        <button type="button" class="close">
          <span aria-hidden="true"> d-xs-block </span>
        </button>
      </div>
      <!-- Separator -->
      <div class="cx-dialog-description">
        BBB
        <div class="cx-dialog-separator col-sm-12 d-xs-block d-sm-block d-md-none"></div>
      </div>
      <!-- Actions -->
      <div class="cx-dialog-buttons">
        <a tabindex="0" class="btn-link cx-action-link">CC</a>
        <a tabindex="0" class="btn-link cx-action-link">DD</a>
      </div>
      <!-- Modal Body -->
      <div class="cx-dialog-body">
        <ng-container>
          <div class="cx-dialog-row col-sm-12 col-md-6">131242441</div>
        </ng-container>
      </div>
    </ng-template>
  </div>
</div>
